import React, { useEffect, useState } from "react";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { Card, CardBody, CardHeader } from "../../../../_metronic/_partials/controls";
import { Col, Row } from "react-bootstrap";
import { Button, Checkbox, createTheme, FormControlLabel, MuiThemeProvider, TextField } from "@material-ui/core";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import { useHistory, useParams, useLocation } from "react-router-dom";
import { deleteClient, getClientById, postClient, updateClient, sendWelcomeEmail } from "../../../../api/client";
import { useSkeleton } from "../../../hooks/useSkeleton";
import MyAutocomplete from "../../../components/MyAutocomplete";
import { getTherapeuticGroupsByTherapist } from "../../../../api/therapeuticGroup";
import { shallowEqual, useSelector } from "react-redux";

// Create theme for delete button (red)
const theme = createTheme({
  palette: {
    secondary: {
      main: '#F64E60'
    }
  }
})

export default function EditClientPage() {
    const clientId = useParams().id
    const history = useHistory();
    const user = useSelector((store) => store.authentication?.user, shallowEqual);
    // const location = useLocation(); ESTA SOLUCION NO ES BUENA YA QUE SI QUITAN EL READONLY DE LA URL YA PUEDEN CAMBIAR TODO
    // const query = new URLSearchParams(location.search);
    // const readOnly = query.get("readonly") === "true";

    const [readOnly, setReadOnly] = useState(false);
    const [client, setClient] = useState(getEmptyClient());
    const [openConfirmDialog, setOpenConfirmDialog] = useState(0);
    const [therapeuticGroups, setTherapeuticGroups] = useState(0);
    const [refresh, setRefresh] = useState(null);


    function getEmptyClient() {
        return {
            active: true,
            createdBy: user?._id
        }
    }
    
    const { isLoading: isLoadingData, disableLoading: disableLoadingData, ContentSkeleton } = useSkeleton()
    
    useEffect(() => {
        setRefresh(false);
    }, [refresh])
    
    useEffect(() => {
        fetch();
    }, [])

    function fetch() {
        getTherapeuticGroupsByTherapist(user?._id)
            .then((res) => {
                setTherapeuticGroups(res.data);
                if (!clientId) {
                    if (res.data.length === 1) {
                        setClient({ ...client, therapeuticGroup: res.data[0] });

                    }
                }
            })
            .catch((error) => {
                if (error.request.status !== 404) {
                    alertError({
                        error,
                        customMessage: "No se han encontraodo grupos terapéuticos que te pertenezcan."
                    })
                }
            })

        if (!clientId) { disableLoadingData(); return;}
        getClientById(clientId)
            .then((res) => {
                const client = res.data;
                setClient(client);
                setReadOnly(!user?.isTherapist || client?.finalized)
                disableLoadingData();
            })
            .catch((error) => {
                alertError({

                    error,
                    customMessage: "No se ha podido encontrar el client."
                })
            })
    }

    function saveClient() {
        if (!client?.therapeuticGroup) {
            alertError({ error: null, message: "El grupo terapéutico es requerido."});
            return;
        }
        if (!client?._id) {
            postClient(client)
                .then((res) => {
                    alertSuccess({ title: "Éxito!", customMessage: "Cliente creado correctamente."});
                    setClient({ ...client, _id: res?.data?.id });
                    setOpenConfirmDialog(2);
                    // history.push("/clients");
                })
                .catch((error) => {
                    alertError({ error, customMessage: "No se ha podido crear el client"});
                })
        }
        else {
            updateClient(client._id, client)
            .then((res) => {
                alertSuccess({ title: "Éxito!", customMessage: "Client actualizado correctamente."});
                history.push("/clients");
            })
            .catch((error) => {
                alertError({ error, customMessage: "Could not update client"});
            })
        }
    }

    const handleChange = (element) => (event) => {
        if (readOnly) return;
        setClient({ ...client, [element]: event.target.value });
    }

    if (isLoadingData) 
        return (<ContentSkeleton />)
    return (
        <>
            <Card>
                <CardHeader title="Editar cliente" />
                <CardBody>
                    <Row>
                        <Col>
                            <TextField
                                label="Nombre"
                                value={client?.fullName}
                                onChange={handleChange("fullName")}
                                margin="normal"
                                variant="outlined"
                                required
                                inputProps={{ readOnly }}
                                className={ readOnly ? "readonly" : ""}
                            />
                        </Col>
                        <Col>
                            <TextField
                                label="Apellidos"
                                value={client?.surname}
                                onChange={handleChange("surname")}
                                margin="normal"
                                variant="outlined"
                                required
                                inputProps={{ readOnly }}
                                className={ readOnly ? "readonly" : ""}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <TextField
                                label="Correo electrónico"
                                value={client?.mail}
                                onChange={handleChange("mail")}
                                margin="normal"
                                variant="outlined"
                                required
                                inputProps={{ readOnly }}
                                className={ readOnly ? "readonly" : ""}
                            />
                        </Col>
                        <Col>
                            <TextField
                                label="Teléfono móvil"
                                value={client?.phone}
                                onChange={handleChange("phone")}
                                margin="normal"
                                variant="outlined"
                                required
                                inputProps={{ readOnly }}
                                className={ readOnly ? "readonly" : ""}
                            />
                        </Col>
                    </Row>
                    { !readOnly && therapeuticGroups?.length > 1 && (
                        <Row>
                            <Col>
                                <MyAutocomplete 
                                    options={ therapeuticGroups }
                                    getOptionLabel={(option) => option.fullName}
                                    value={client?.therapeuticGroup}
                                    onChange={(event, selected) => {
                                        setClient({ ...client, therapeuticGroup: selected });
                                        setRefresh(true);
                                    }}
                                    placeholder="Selecciona el grupo terapéutico ya que tienes varios asignados"
                                    label={"Grupo terapéutico"}
                                />
                            </Col>
                        </Row>
                    )}
                    { (readOnly && client?.therapeuticGroup) && (
                        <Row>
                            <Col>
                                <TextField
                                    label="Grupo terapéutico"
                                    value={client?.therapeuticGroup?.fullName}
                                    margin="normal"
                                    variant="outlined"
                                    required
                                    inputProps={{ readOnly }}
                                    className={ readOnly ? "readonly" : ""}
                                />
                            </Col>
                        </Row>
                    )}
                    <Row>
                        <Col>
                            <FormControlLabel
                                control={
                                    <Checkbox checked={client?.active} 
                                    onChange={() => !readOnly && setClient({ ...client, active: !client?.active })} 
                                    name="checkActive" />
                                }
                                label="Activo"
                            />
                        </Col>
                    </Row>
                </CardBody>
            </Card>
            <Button
                onClick={() => history.push('/clients')}
                variant="outlined"
                style={{ marginRight: '20px' }}>
                Atrás
            </Button>
            { !readOnly && (<>
                <Button
                    onClick={() => saveClient()}
                    variant="outlined"
                    color="primary"
                    style={{ marginRight: '20px' }}>
                    Save client
                </Button>
                {client?._id && <>
                            <MuiThemeProvider theme={theme}>
                            <Button
                                onClick={() => setOpenConfirmDialog(1)}
                                style={{ marginRight: '20px' }}
                                variant="outlined"
                                color="secondary">
                                Delete client
                            </Button>
                            </MuiThemeProvider>

                            <ConfirmDialog
                            title={'Seguro que quieres eliminar el cliente?'}
                            open={openConfirmDialog === 1}
                            setOpen={setOpenConfirmDialog}
                            onConfirm={() => {
                                deleteClient(client._id)
                                    .then((res) => {
                                        alertSuccess({ title: "Éxito!", customMessage: "Cliente eliminado correctamente." });
                                        history.push("/clients");
                                    })
                                    .catch((error) => {
                                        alertError({ error, customMessage: "No se ha podido eliminar el client." });
                                    })
                            }}
                            />

                            { !client?.block1Done && (
                                <Button
                                    onClick={() => setOpenConfirmDialog(2)}
                                    variant="outlined"
                                    >
                                    Enviar mail bienvenida
                                </Button>
                            )}

                            {/* Este puede salir nada mas se crea el cliente */}
                            <ConfirmDialog
                            title={'Quieres enviar el correo de inicio de la terapia?'}
                            open={openConfirmDialog === 2}
                            setOpen={setOpenConfirmDialog}
                            onConfirm={() => {
                                sendWelcomeEmail(client?._id)
                                    .then((res) => {
                                        alertSuccess({ title: "Éxito!", customMessage: "Email enviado correctamente!" });

                                    })
                                    .catch((error) => {
                                        alertError({ error, customMessage: "No se ha podido eliminar el client." });
                                    })
                            }}
                            />
                </>}
            </>)}
        </>
    )
}